import { OnChangeHandler } from "components/base/input-field/Input";
import { useState, useRef, useCallback } from "react";

const MIN_SEARCH_CHAR_COUNT = 2;

export const useSearchState = (defaultShowInput: boolean) => {
    const [isActive, setIsActive] = useState(false);
    const [inputVisible, setInputVisible] = useState(defaultShowInput);
    const [showResults, setShowResults] = useState(false);
    const [searchValue, setSearchValue] = useState("");

    const inputRef = useRef<HTMLInputElement>(null);

    const onChange: OnChangeHandler<false> = useCallback((val) => {
        setSearchValue(val);

        if (val.length >= MIN_SEARCH_CHAR_COUNT) {
            setShowResults(true);
        } else {
            setShowResults(false);
        }
    }, []);

    const onIconClick = useCallback(() => {
        if (!defaultShowInput) {
            setInputVisible(true);
        }
    }, [defaultShowInput]);

    const handleClose = useCallback(() => {
        setIsActive(false);
        setSearchValue("");
        setShowResults(false);

        if (!defaultShowInput) {
            setInputVisible(false);
        }
    }, [defaultShowInput]);

    const onInputClick = useCallback(() => {
        setIsActive(true);
    }, []);

    return {
        searchValue,
        inputVisible,
        isActive,
        inputRef,
        minSearchCharCount: MIN_SEARCH_CHAR_COUNT,
        onChange,
        onIconClick,
        handleClose,
        showResults,
        setShowResults,
        onInputClick,
    };
};
